import { lazy } from "react";
import { RouteConfig } from "../../types/RouteConfig";

export const membershipHubRoute: RouteConfig<'with-page'> = {
    name: 'Membership Hub',
    path: '/developer/membership-hub',
    page: lazy(() => import('.')),
    icon: 'mdi mdi-card-account-details-outline',
    roles: ['developer'],
}
